export default "__VITE_ASSET__52e5fae3__"